/**
 * Converts a hex color to a color with alpha transparency
 * @param hex - The hex color string (e.g. "#FF0000" or "#F00")
 * @param alpha - The alpha value between 0 and 1
 * @returns RGBA color string (e.g. "rgba(255, 0, 0, 0.5)")
 */
export const hexToAlpha = (hex: string, alpha: number): string => {
  // Remove # if present
  hex = hex.replace("#", "");

  // Convert 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Ensure alpha is between 0 and 1
  const normalizedAlpha = Math.min(Math.max(alpha, 0), 1);

  // Return rgba string
  return `rgba(${r}, ${g}, ${b}, ${normalizedAlpha})`;
};
